/**
 * The one rule the task page applies itself: where a merge expectation is
 * meaningful. Mirrors the server rule and the 0015 CHECK.
 */

/**
 * Where a merge expectation is meaningful — code work, both kinds. Mirrors
 * the server rule and the 0015 CHECK; annotation work has no merge.
 */
export function mergeExpectationApplies(taskType: string): boolean {
  return taskType === 'DEVELOPMENT' || taskType === 'RESEARCH_AND_DEVELOPMENT';
}
